/**
 * DeliveryFilterGroup
 *
 * Provides the functionality for handling a radio button filter.
 *
 * @return {view}
 */

 OT.createNS('OT.Redesign.Views.Filters.DeliveryFilterGroup');

OT.Redesign.Views.Filters.DeliveryFilterGroup = Backbone.ViewManager.BaseView.extend({
    el: '#delivery_filters',
    events: {
    },

    initialize: function() {
        var self = this;
        OT.Events.on('filters:update', function(e,filterDiffs) {
            self.resetAllFilters(filterDiffs);
        });

        $('#delivery_filters').find('.dining-type-filter-row').click(function (e) {
            self.updateFilteredSearch(e);
        });
    },

    resetAllFilters: function(filterDiffs) {
        var resetFilter = filterDiffs.find(function(f) {
            return f.id === 'DiningType_All' & f.value === false;
        });

        if(resetFilter) {
            var all = $('#delivery_filters').find("[data-id=All]");
            all.prop('checked', true);
        }
    },

    toggleAllFilteredSearch: function (e) {
        var data = e.target.dataset;
        OTSearchBundle.setAllFiltersTo(data.name, false);
    },

    updateFilteredSearch: function(e) {
        var data = e.target.dataset;
        if (data.id === 'All') {
            return this.toggleAllFilteredSearch(e);
        }
        window.OTDataLayer.push({ event: data.id + '_search_filter_click' });
        OTSearchBundle.toggleFilter(data.name, data.id);
    }
});
